import { makeStyles } from "@material-ui/core";
import styled from "styled-components";
import { theme as themeConfig } from '@themes';

export const ContentFilters = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-direction: row;
  width: 100%;
  animation: scale-up-hor-left 0.4s cubic-bezier(0.39, 0.575, 0.565, 1) both;
  @keyframes scale-up-hor-left {
    0% {
      transform: scaleX(0.5);
      transform-origin: 0% 0%;
    }
    100% {
      transform: scaleX(1);
      transform-origin: 0% 0%;
    }
  }
`;
export const ActionButtons = styled.div`
  display: grid;
  align-items: center;
  grid-template-columns: 2fr 9fr 1fr;
  @media only screen and (min-width: 769px) {
    grid-template-columns: 2fr 9fr 1fr;
  }
  @media only screen and (min-width: 491px) and (max-width: 768px) {
    grid-template-columns: 2fr 9fr 1fr;
  }
  @media only screen and (max-width: 480px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
  .right-section {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  .table-action {
    margin-right: 20px;
  }
`;
export const ContentTable = styled.div`
  margin: 26px 20px 20px 26px;
  .MuiPaper-root {
    box-shadow: none;
  }
  .MuiIconButton-colorInherit {
    border-radius: 0px;
    margin-right: 0px;
    padding: 0px;
    height: 1.7em;
  }
  .MuiIcon-colorPrimary {
    color: ${themeConfig.primary.purple};
    border: 1px solid ${themeConfig.neutral.gray[400]};
    width: 1.7em;
    height: 1.7em;
    font-size: 1em;
    display: flex;
    align-items: center;
    justify-content: center;
    border-right: none;
  }
  .MuiIcon-colorSecondary {
    color: ${themeConfig.text.primary};
    border: 1px solid ${themeConfig.neutral.gray[400]};
    width: 1.7em;
    height: 1.7em;
    font-size: 1em;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .MuiPaper-root {
    background-color: ${themeConfig.background.light};
    box-shadow: none;
  }
  .MuiTableCell-alignLeft {
    text-align: center;
  }
  .MuiTableCell-root {
    padding: 12px;
  }
  th {
    background-color: ${themeConfig.neutral.gray[800]} !important;
    z-index: 1 !important;
  }
  tr:nth-child(even) {
    background-color: ${themeConfig.neutral.gray[200]};
  }
  .MuiPaper-root > .MuiToolbar-root {
    display: none;
  }
  .MuiFormControlLabel-root {
    margin: 0;
  }
`;
export const Convention = styled.div`
  display: flex;
  width: 22em;
  align-items: center;
  p {
    margin: 0 1em 0 0.4em;
  }
`;
export const ContentLoader = styled.div`
  grid-column: 1/4;
  display: flex;
  text-align: center;
  height: 69vh;
  align-items: center;
`;
export const TableViewButton = styled.div`
  border: 1px solid ${themeConfig.neutral.gray[400]};
  border-radius: 1px;
  background: ${themeConfig.neutral.white};
  width: 40px;
  height: 40px;
  .list-view {
    color: ${({ iconColor }) => (iconColor ? themeConfig.text.primary : themeConfig.tabs.selected)};
  }
  .card-view {
    color: ${({ iconColor }) => (iconColor ? themeConfig.tabs.selected : themeConfig.text.primary)};
  }
`;
export const useStyles = makeStyles((theme) => ({
  active: {
    "& svg": {
      color: themeConfig.button.primary,
    },
    "&:disabled svg": {
      color: themeConfig.neutral.gray[1200],
    },
  },
  delete: {
    color: themeConfig.status.error,
  },
  buttonActive: {
    background: themeConfig.tabs.selected,
    color: "white",
    height: "29px",
    padding: "3px 10px",
    fontSize: "12px",
  },
  tabs: {
    backgroundColor: themeConfig.background.paper,
  },
}));
